module.exports = __webpack_public_path__ + "img/edit_icon.682b5704.svg";